import { SUCCESS_SURVEY_STATUSES, FAILED_SURVEY_STATUSES } from 'src/constants/misc';
import { TWILIO_ERROR_CODES } from 'src/constants/twilio-error-codes';
import { Chip, Tooltip } from '@mui/material';

export const SurveyStatusBadge = ({ value, twilioErrorCode }) => {
  let chipColor = 'warning';
  let failed = false;
  if (SUCCESS_SURVEY_STATUSES.includes(value)) {
    chipColor = 'success';
  }
  if (FAILED_SURVEY_STATUSES.includes(value)) {
    chipColor = 'error';
    failed = true;
  }
  const chip = (
    <Chip
      sx={{ textTransform: 'capitalize' }}
      variant="soft"
      size="small"
      label={value}
      color={chipColor}
    />
  );

  if (failed) {
    const errorMessage = twilioErrorCode
      ? TWILIO_ERROR_CODES[twilioErrorCode]?.message ?? twilioErrorCode
      : null;
    if (errorMessage) {
      return (
        <Tooltip title={errorMessage} arrow>
          {chip}
        </Tooltip>
      );
    }
    return chip;
  }
  return chip;
};
